module.exports = __webpack_public_path__ + "img/foot.b873f1f8.png";